import { fetchActiveProviders } from '../../stores/categories/Providers';

import { useQuery } from './useCustomQuery';

export const useActiveProviders = () => {
  return useQuery({
    queryKey: ['active-providers'],
    queryFn: fetchActiveProviders,
  });
};
